import { UIView } from "@uirouter/react";
import type { FC } from "react";

export const ResearchRoot: FC = () => {
    return (
        <div className="sw-layout-module sw-layout-no-scroll-container fadeIn">
            <UIView />
        </div>
    );
};
